import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { useNavigate } from 'react-router-dom';
import { TriggerDetailsPage } from '../../triggers/TriggerDetailsPage';

export function QuadTriggerRules() {
    const navigate = useNavigate();

    const handleCancelTriggerRuleEditor = () => {
        navigate(LocalRoutes.QuadDashboard);
    };

    const handleSaveTriggerRuleComplete = () => {
        navigate(LocalRoutes.QuadDashboard);
    };

    return <TriggerDetailsPage isCreate={true} isQuadScope={true} />;
}
